// Plan ▸ Mind Maps: notes on paper joined by lines, the map in use in this browser, with the map menu and the zoom.
export { MindMapsPage as component, MapControls as headerControls } from '../../views/maps/MindMapsPage.tsx';
export const room = 'plan';
export const page = 'maps';
export const title = 'Mind Maps';
export const help = 'mind-maps';
